/**
 * Splash Screen Component
 * Displays a branded loading screen while the app initializes
 */
import {
  Component,
  ChangeDetectionStrategy,
  inject,
  computed,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplashScreenService } from '../../../core/services/splash-screen.service';

@Component({
  selector: 'app-splash-screen',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (isVisible()) {
      <div
        class="splash-screen"
        [class.fade-out]="isHiding()"
        role="status"
        aria-label="Cargando aplicación"
      >
        <div class="splash-content">
          <div class="splash-logo-container">
            <img
              src="gastronauta_logo_simple.png"
              alt="Gastronauta"
              class="splash-logo"
            />
          </div>
          <div class="splash-branding">
            <div class="splash-branding-title">Gastronauta</div>
          </div>
        </div>
      </div>
    }
  `,
  styles: [
    `
      .splash-screen {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #e91d63;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10000;
        opacity: 1;
        transition: opacity 0.4s ease-out;
        pointer-events: all;
      }

      .splash-screen.fade-out {
        opacity: 0;
        pointer-events: none;
      }

      .splash-content {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .splash-logo-container {
        width: 140px;
        height: 140px;
        background-color: white;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
        animation: splash-float 2s ease-in-out infinite;
      }

      .splash-logo {
        width: 100px;
        height: 100px;
        object-fit: contain;
      }

      .splash-branding {
        margin-top: 20px;
        text-align: center;
        color: white;
        font-family: 'Nunito', sans-serif;
      }

      .splash-branding-title {
        font-size: 1.75rem;
        font-weight: 700;
        letter-spacing: 0.5px;
        margin-bottom: 4px;
      }

      .splash-branding-subtitle {
        font-size: 0.875rem;
        font-weight: 400;
        opacity: 0.9;
        letter-spacing: 0.3px;
      }

      @keyframes splash-float {
        0%,
        100% {
          transform: translateY(0) scale(1);
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
        }
        50% {
          transform: translateY(-10px) scale(1.03);
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
        }
      }
    `,
  ],
})
export class SplashScreenComponent {
  private splashService = inject(SplashScreenService);

  // Expose service signals to template
  isVisible = computed(() => this.splashService.isVisible());
  isHiding = computed(() => this.splashService.isHiding());
}
